import { Popover } from "@cloudscape-design/components";
import React from "react";
import { getBookingType } from "../../pages/commons/functions";
import { useGlobalState } from "../../pages/context/GlobalStateContext";
import BadgeCustom from "./BadgeCustom";

type BadgeBookingTypeProps = {
  idBookingType: number;
  size?: "small" | "medium" | "large";
  type?: "min" | "normal",
  width?: number;
};

const BadgeBookingType: React.FC<BadgeBookingTypeProps> = ({ idBookingType = 0, size = "small", type = "normal", width = 0 }) => {
  const { data } = useGlobalState();
  const color = getBookingType(idBookingType, data).bookingTypeBadge || "gray";
  const bookingType = getBookingType(idBookingType, data);
  return (
    <>
      <BadgeCustom color={color} size={size}>
        {/* If type is "min", wrap the abbreviation (userType.ut) in a Popover 
                    that shows the full name (userType.displayName) on hover.
                */}
        {type === "min" ? (
          <Popover content={bookingType.bookingType ?? null}
            dismissButton={false} triggerType="custom">
            {bookingType.bookingTypeCode.substring(0, 2)}
          </Popover>
        ) : (
          /* Otherwise, show the full display name */
          bookingType.bookingType
        )}
      </BadgeCustom>
    </>
  );
};

export default BadgeBookingType;
